import React, { useEffect, useState } from "react";
import { heroSlides } from "../mock";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function HeroSlider() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const t = setInterval(
      () => setActive((p) => (p + 1) % heroSlides.length),
      5500
    );
    return () => clearInterval(t);
  }, []);

  const prev = () => setActive((p) => (p - 1 + heroSlides.length) % heroSlides.length);
  const next = () => setActive((p) => (p + 1) % heroSlides.length);

  return (
    <section className="relative h-[88vh] min-h-[560px] max-h-[820px] w-full overflow-hidden bg-[#0e1b34]">
      {heroSlides.map((s, i) => (
        <div key={s.id} className={`hero-slide ${i === active ? "active" : ""}`}>
          <img src={s.image} alt={s.title} className="kenburns" loading={i === 0 ? "eager" : "lazy"} />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0a1428]/90 via-[#0a1428]/70 to-[#0a1428]/40" />
        </div>
      ))}

      <div className="relative z-10 h-full container-x flex flex-col justify-center">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-[1px] w-10 bg-[#c9a961]" />
            <span className="text-[#c9a961] uppercase tracking-[0.35em] text-xs font-semibold">
              {heroSlides[active].subtitle}
            </span>
          </div>
          <h1 className="font-serif-display text-white text-4xl md:text-6xl lg:text-7xl leading-[1.05] font-semibold mb-8">
            {heroSlides[active].title}
          </h1>
          <div className="flex flex-wrap items-center gap-4">
            <a href="#appointment" className="btn-gold">
              Fix An Appointment
            </a>
            <a href="#about" className="btn-outline-gold">
              Discover More
            </a>
          </div>
        </div>
      </div>

      {/* Controls */}
      <button
        onClick={prev}
        className="hidden md:flex absolute left-6 top-1/2 -translate-y-1/2 z-10 w-12 h-12 rounded-full border border-white/30 text-white/80 hover:border-[#c9a961] hover:text-[#c9a961] items-center justify-center backdrop-blur-sm transition-colors"
        aria-label="Previous slide"
      >
        <ChevronLeft size={22} />
      </button>
      <button
        onClick={next}
        className="hidden md:flex absolute right-6 top-1/2 -translate-y-1/2 z-10 w-12 h-12 rounded-full border border-white/30 text-white/80 hover:border-[#c9a961] hover:text-[#c9a961] items-center justify-center backdrop-blur-sm transition-colors"
        aria-label="Next slide"
      >
        <ChevronRight size={22} />
      </button>

      {/* Dots */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex items-center gap-2">
        {heroSlides.map((_, i) => (
          <button
            key={i}
            onClick={() => setActive(i)}
            className={`dot ${i === active ? "active" : ""}`}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>

      {/* Slide count */}
      <div className="absolute bottom-8 right-8 z-10 hidden md:block text-white/70 text-sm tracking-widest">
        <span className="text-[#c9a961] font-semibold text-lg">
          {String(active + 1).padStart(2, "0")}
        </span>
        <span className="mx-2">/</span>
        {String(heroSlides.length).padStart(2, "0")}
      </div>
    </section>
  );
}
